import { render, staticRenderFns } from "./OpacityCover.vue?vue&type=template&id=768ddff8&scoped=true&"
import script from "./OpacityCover.vue?vue&type=script&lang=js&"
export * from "./OpacityCover.vue?vue&type=script&lang=js&"
import style0 from "./OpacityCover.vue?vue&type=style&index=0&id=768ddff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ddff8",
  null
  
)

export default component.exports